/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateOrderLabelRequest,
  LabelOptionResponse,
  OrderLabelResponse,
} from '../models/index';
import {
    CreateOrderLabelRequestFromJSON,
    CreateOrderLabelRequestToJSON,
    LabelOptionResponseFromJSON,
    LabelOptionResponseToJSON,
    OrderLabelResponseFromJSON,
    OrderLabelResponseToJSON,
} from '../models/index';

export interface OrderLabelsCreateOrderLabelPOSTRequest {
    createOrderLabelRequest?: CreateOrderLabelRequest;
}

export interface OrderLabelsDeleteLabelDELETERequest {
    id: string;
}

/**
 * OrderLabelsApi - interface
 * 
 * @export
 * @interface OrderLabelsApiInterface
 */
export interface OrderLabelsApiInterface {
    /**
     * Creates request options for orderLabelsCreateOrderLabelPOST without sending the request
     * @param {CreateOrderLabelRequest} [createOrderLabelRequest] 
     * @throws {RequiredError}
     * @memberof OrderLabelsApiInterface
     */
    orderLabelsCreateOrderLabelPOSTRequestOpts(requestParameters: OrderLabelsCreateOrderLabelPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {CreateOrderLabelRequest} [createOrderLabelRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderLabelsApiInterface
     */
    orderLabelsCreateOrderLabelPOSTRaw(requestParameters: OrderLabelsCreateOrderLabelPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderLabelResponse>>;

    /**
     */
    orderLabelsCreateOrderLabelPOST(requestParameters: OrderLabelsCreateOrderLabelPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderLabelResponse>;

    /**
     * Creates request options for orderLabelsDeleteLabelDELETE without sending the request
     * @param {string} id 
     * @throws {RequiredError}
     * @memberof OrderLabelsApiInterface
     */
    orderLabelsDeleteLabelDELETERequestOpts(requestParameters: OrderLabelsDeleteLabelDELETERequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderLabelsApiInterface
     */
    orderLabelsDeleteLabelDELETERaw(requestParameters: OrderLabelsDeleteLabelDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    orderLabelsDeleteLabelDELETE(requestParameters: OrderLabelsDeleteLabelDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for orderLabelsGetDistinctLabelsGET without sending the request
     * @throws {RequiredError}
     * @memberof OrderLabelsApiInterface
     */
    orderLabelsGetDistinctLabelsGETRequestOpts(): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderLabelsApiInterface
     */
    orderLabelsGetDistinctLabelsGETRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LabelOptionResponse>>>;

    /**
     */
    orderLabelsGetDistinctLabelsGET(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LabelOptionResponse>>;

}

/**
 * 
 */
export class OrderLabelsApi extends runtime.BaseAPI implements OrderLabelsApiInterface {

    /**
     * Creates request options for orderLabelsCreateOrderLabelPOST without sending the request
     */
    async orderLabelsCreateOrderLabelPOSTRequestOpts(requestParameters: OrderLabelsCreateOrderLabelPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/OrderLabels`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrderLabelRequestToJSON(requestParameters['createOrderLabelRequest']),
        };
    }

    /**
     */
    async orderLabelsCreateOrderLabelPOSTRaw(requestParameters: OrderLabelsCreateOrderLabelPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderLabelResponse>> {
        const requestOptions = await this.orderLabelsCreateOrderLabelPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderLabelResponseFromJSON(jsonValue));
    }

    /**
     */
    async orderLabelsCreateOrderLabelPOST(requestParameters: OrderLabelsCreateOrderLabelPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderLabelResponse> {
        const response = await this.orderLabelsCreateOrderLabelPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for orderLabelsDeleteLabelDELETE without sending the request
     */
    async orderLabelsDeleteLabelDELETERequestOpts(requestParameters: OrderLabelsDeleteLabelDELETERequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling orderLabelsDeleteLabelDELETE().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/OrderLabels/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async orderLabelsDeleteLabelDELETERaw(requestParameters: OrderLabelsDeleteLabelDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.orderLabelsDeleteLabelDELETERequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderLabelsDeleteLabelDELETE(requestParameters: OrderLabelsDeleteLabelDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.orderLabelsDeleteLabelDELETERaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for orderLabelsGetDistinctLabelsGET without sending the request
     */
    async orderLabelsGetDistinctLabelsGETRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/OrderLabels/distinct`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async orderLabelsGetDistinctLabelsGETRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LabelOptionResponse>>> {
        const requestOptions = await this.orderLabelsGetDistinctLabelsGETRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LabelOptionResponseFromJSON));
    }

    /**
     */
    async orderLabelsGetDistinctLabelsGET(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LabelOptionResponse>> {
        const response = await this.orderLabelsGetDistinctLabelsGETRaw(initOverrides);
        return await response.value();
    }

}
